import { useEffect } from 'react';
import { phraseLinkClassName } from '@/consts/classNames';
import { useRouter } from '@/hooks';
import { config } from '@/config';

const isRoutingForLinksEnabled = config.routingForLinksInPhrasesEnabled === 'true';

export const useNextRouterForLinksInPhrases = () => {
    const router = useRouter();

    useEffect(() => {
        if (!isRoutingForLinksEnabled) return;
        const clickHandlerForLinksInPhrases = (evt: MouseEvent) => {
            const target = evt.target as HTMLAnchorElement;
            if (target.classList.contains(phraseLinkClassName)) {
                evt.preventDefault();
                const url = target.getAttribute('href');
                if (url) router.push(url);
            }
        };
        window.addEventListener('click', clickHandlerForLinksInPhrases);
        return () => window.removeEventListener('click', clickHandlerForLinksInPhrases);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
